import MenuItem from 'antd/es/menu/MenuItem';
import React from 'react';

import {ITableActionProps} from 'components/table/action/table-action-types';
import {CustomLink} from 'features/provide-custom-link';
import {selectEntityData} from 'modules/data';
import {selectTableEntityData} from 'modules/data/data-selectors';
import {ITableEntityData} from 'modules/data/data-types';
import {EEntityType} from 'shared/constants/entities';
import {TLinkDto} from 'shared/types/links';
import {useAppSelector} from 'store/config/hooks';

interface IDrillDownActionLinkProps extends ITableActionProps {}

export const DrillDownActionLink = ({
    entityName,
    meta,
    wrapper,
    ...props
}: IDrillDownActionLinkProps) => {
    const {
        actionTitle,
        key: linkDtoKey,
    } = meta;

    const {selectedRowKeys = []} = useAppSelector(s => (
        selectEntityData(entityName, EEntityType.TABLE)(s) || {}
    ) as ITableEntityData);

    const rows = useAppSelector(selectTableEntityData(entityName || ''))?.rows;
    const selectedRow = rows?.find(r => r.id === selectedRowKeys[0]) ?? {};
    const isSubmenu = !!wrapper;
    const linkConfig = linkDtoKey ? (selectedRow[linkDtoKey] as TLinkDto) : undefined;

    const customLinkButton = selectedRowKeys.length === 1 ? (
        <CustomLink
            link={linkConfig}
            externalProperties={{
                title: actionTitle,
            }}
            isSubmenuItem
        />
    ) : actionTitle;

    return (
        isSubmenu ? (
            <MenuItem
                key={meta.actionTitle}
                {...props}
                disabled={selectedRowKeys.length !== 1}

            >
                {customLinkButton}
            </MenuItem>
        ) : (
            <div>
                {customLinkButton}
            </div>
        )
    );
};
